import {
  EducatorsListingProfilesTeamListingProfileForm,
  EducatorsListingProfilesTagCategory,
  EducatorsTeamsIndex,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  teams: Array<EducatorsTeamsIndex>
}
export const useIndexProps = () => useProps<IndexProps>()

export type FormProps = {
  listing_profile: EducatorsListingProfilesTeamListingProfileForm
  tag_categories: Array<EducatorsListingProfilesTagCategory>
}
export const useFormProps = () => useProps<FormProps>()

export type NewProps = FormProps
export type EditProps = FormProps
